module.exports = __webpack_public_path__ + "info.c8830947f7f931145bf4256c8ca6c615.svg";